module.exports = __webpack_public_path__ + "media/images/segment_engineer-e5747e78afc4c089ef7884976fefdba0.svg";